'use client';

import * as Popover from '@radix-ui/react-popover';
import { useEffect, useState } from 'react';

export const DeprecatedDropdown = ({
  renderTrigger,
  children,
  variant = 'default',
  align = 'end',
  zIndex = 0,
  asPortal = false,
  defaultOpen = false,
  onOpenChange,
  avoidCollisions,
  collisionPadding,
}: {
  renderTrigger: (props: { className: string }) => React.ReactNode;
  children: React.ReactNode;
  variant?: 'default' | 'primary';
  align?: 'start' | 'end' | 'center';
  zIndex?: number;
  asPortal?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  avoidCollisions?: boolean;
  collisionPadding?: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsOpen(defaultOpen);
    }, 10);
  }, [defaultOpen]);

  const contentClass = {
    default: 'w-auto rounded border border-2 border-black bg-white p-1.5 mt-2',
    primary: 'w-auto bg-white rounded shadow-lg p-1.5 mt-2',
  };

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        onOpenChange?.(open);
      }}
    >
      <Popover.Trigger className='bg-transparent bg-none p-0'>
        {renderTrigger?.({
          className: `rounded bg-white border border-slate-200 px-2 py-1.5 hover:border-slate-300 hover:bg-white hover:shadow-buttonHover focus:outline-none cursor-pointer`,
        })}
      </Popover.Trigger>
      {asPortal ? (
        <Popover.Portal>
          <Popover.Content
            className={contentClass[variant]}
            style={{
              borderRadius: 6,
              background: 'var(--white, #FFF)',
              boxShadow:
                '0px 4px 6px -4px rgba(15, 23, 42, 0.10), 0px 10px 15px -3px rgba(15, 23, 42, 0.10), 0px 0px 0px 1px rgba(15, 23, 42, 0.10)',
              zIndex,
            }}
            align={align}
            avoidCollisions={avoidCollisions}
            collisionPadding={collisionPadding}
          >
            {children}
          </Popover.Content>
        </Popover.Portal>
      ) : (
        <Popover.Content
          sideOffset={0}
          className={contentClass[variant]}
          style={{
            borderRadius: 6,
            background: 'var(--white, #FFF)',
            boxShadow:
              '0px 4px 6px -4px rgba(15, 23, 42, 0.10), 0px 10px 15px -3px rgba(15, 23, 42, 0.10), 0px 0px 0px 1px rgba(15, 23, 42, 0.10)',
            zIndex,
          }}
          align={align}
          avoidCollisions={avoidCollisions}
          collisionPadding={collisionPadding}
        >
          {children}
        </Popover.Content>
      )}
      {/* This is to close the dropdown when clicked outside without interacting with elements below, also blocks scrolling below */}
      {isOpen && (
        <div
          className='absolute left-0 top-0 h-full w-full'
          style={{ zIndex: zIndex ? zIndex - 1 : 0 }}
        />
      )}
    </Popover.Root>
  );
};
